import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';

var TitleSection = function TitleSection() {
  return import(
  /* webpackChunkName: "title-section", webpackMode: "eager" */
  '~/components/atoms/Editorial/TitleSection.vue');
};

var SubtitleSection = function SubtitleSection() {
  return import(
  /* webpackChunkName: "subtitle-section", webpackMode: "eager" */
  '~/components/atoms/Editorial/SubtitleSection.vue');
};

var SimpleParagraph = function SimpleParagraph() {
  return import(
  /* webpackChunkName: "simple-paragraph", webpackMode: "eager" */
  '~/components/atoms/Editorial/SimpleParagraph.vue');
};

var MainImage = function MainImage() {
  return import(
  /* webpackChunkName: "main-image", webpackMode: "eager" */
  '~/components/atoms/Editorial/MainImage.vue');
};

var MdmLink = function MdmLink() {
  return import(
  /* webpackChunkName: "mdm-link", webpackMode: "eager" */
  '~/components/atoms/MdmLink.vue');
};

export default {
  name: 'GlobalDispatchFooter',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph,
    MainImage: MainImage,
    MdmLink: MdmLink
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    background: function background() {
      return {
        color: this.payload.primary.background_color || '',
        image: formatPrismicImage(this.payload.primary.image.url) || ''
      };
    },
    title: function title() {
      return {
        text: Object.keys(this.payload.primary.title).length === 0 ? '' : this.payload.primary.title[0],
        color: this.payload.primary.title_color || ''
      };
    },
    subtitle: function subtitle() {
      return {
        text: Object.keys(this.payload.primary.subtitle).length === 0 ? '' : this.payload.primary.subtitle[0],
        color: this.payload.primary.subtitle_color || ''
      };
    },
    simpleParagraph: function simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },
    legals: function legals() {
      return this.payload.primary.legals || '';
    },
    elements: function elements() {
      return this.payload.items.map(function (item) {
        var small = formatPrismicImage(item.image.url, ['w_375']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_1440']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
        return {
          src: large,
          srcset: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
          alt: item.alt || '',
          title: Object.keys(item.title).length === 0 ? '' : item.title[0],
          titleColor: item.title_color,
          simpleParagraphItem: item.simple_paragraph_item || [],
          button: {
            url: item.button_url.url || '',
            text: item.button_text || ''
          },
          tracking: {
            data: {
              event_category: item.event_category || '',
              event_action: item.event_action || '',
              event_label: item.event_label || ''
            }
          }
        };
      });
    }
  })
};